import { render } from "./IncludeEmployeeDropdown.vue?vue&type=template&id=50645d46"
import script from "./IncludeEmployeeDropdown.vue?vue&type=script&lang=js"
export * from "./IncludeEmployeeDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__